import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import { FloatingCallButton } from "./components/ui/FloatingCallButton";

// Pages
import HomePage from "./pages/HomePage";
import ToursPage from "./pages/ToursPage";
import TourDetailPage from "./pages/TourDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import BookingsPage from "./pages/BookingsPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AdminDashboard from "./pages/AdminDashboard";
import InvoicePaymentPage from "./pages/InvoicePaymentPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import CustomPage from "./pages/CustomPage";
import JoinTeamPage from "./pages/JoinTeamPage";
import ProviderDashboardPage from "./pages/ProviderDashboardPage";
import WaiverSigningPage from "./pages/WaiverSigningPage";
import BecomeReferralAgentPage from "./pages/BecomeReferralAgentPage";
import ReferralAgentDashboardPage from "./pages/ReferralAgentDashboardPage";
import ReferralRedirectPage from "./pages/ReferralRedirectPage";
import ReferralLeaderboardPage from "./pages/ReferralLeaderboardPage";
import ServiceProvidersPage from "./pages/ServiceProvidersPage";
import ServiceProviderDashboardPage from "./pages/ServiceProviderDashboardPage";
import CustomerPortalPage from "./pages/CustomerPortalPage";
import AuthCallback from "./pages/AuthCallback";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/tours" element={<ToursPage />} />
              <Route path="/tours/:id" element={<TourDetailPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              
              {/* Google OAuth Callback */}
              <Route path="/auth/callback" element={<AuthCallback />} />
              
              {/* Invoice Payment (Public) */}
              <Route path="/pay/:invoiceId" element={<InvoicePaymentPage />} />
              
              {/* Custom Pages (Public) */}
              <Route path="/page/:slug" element={<CustomPage />} />
              
              {/* Protected Routes */}
              <Route path="/bookings" element={<BookingsPage />} />
              <Route path="/checkout/:bookingId" element={<CheckoutPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/booking-success" element={<BookingSuccessPage />} />
              
              {/* Customer Portal */}
              <Route path="/my-bookings" element={<CustomerPortalPage />} />
              
              {/* Join Team / Provider Application (Public) */}
              <Route path="/join-team" element={<JoinTeamPage />} />
              
              {/* Waiver Signing (Public) */}
              <Route path="/waiver/:referenceNumber/:waiverToken" element={<WaiverSigningPage />} />
              
              {/* Provider Dashboard (For tour operators) */}
              <Route path="/provider" element={<ProviderDashboardPage />} />
              
              {/* Referral Agent Routes */}
              <Route path="/become-referral-agent" element={<BecomeReferralAgentPage />} />
              <Route path="/referral-agents" element={<BecomeReferralAgentPage />} />
              <Route path="/referral-agent/dashboard" element={<ReferralAgentDashboardPage />} />
              <Route path="/referral-dashboard" element={<ReferralAgentDashboardPage />} />
              <Route path="/referral-leaderboard" element={<ReferralLeaderboardPage />} />
              <Route path="/r/:code/:tourId" element={<ReferralRedirectPage />} />
              
              {/* Service Provider Routes */}
              <Route path="/service-providers" element={<ServiceProvidersPage />} />
              <Route path="/service-provider/dashboard" element={<ServiceProviderDashboardPage />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            
            {/* Floating Call Button - appears on all pages */}
            <FloatingCallButton />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </LanguageProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
